import styled from "styled-components";

import { appLayoutStyles } from "../styles/appLayoutStyles";

const MasterLayoutStyleHTML = styled.div`
    ${appLayoutStyles}
`;

export const MasterLayout = styled(MasterLayoutStyleHTML).attrs(() => ({ className: "aevi-master" as string }))``;
